import { render, staticRenderFns } from "./UpsertPrepAreaModal.vue?vue&type=template&id=1df5389c&"
import script from "./UpsertPrepAreaModal.vue?vue&type=script&lang=ts&"
export * from "./UpsertPrepAreaModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports